module.exports = __webpack_public_path__ + "static/media/carrots.416c6591.svg";